module.exports = __webpack_public_path__ + "static/media/IMG_9606.021f26d7.jpg";